<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="tabela && !loading">
      <div>
        <b-table
          responsive="sm"
          :items="dadosInfoBancarias"
          :fields="camposInfoBancarias"
          per-page="1000"
          striped
        >
          <template #cell(options)="data">
            <div class="d-flex justify-content-end">
              <b-button
                size="sm"
                class="me-1"
                variant="primary"
                @click="editarInfoBancarias(data.item)"
                data-tooltip="Editar"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="me-1"
                variant="danger"
                @click="excluirInfoBancarias(data.item)"
                data-tooltip="Excluir"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-trash-can"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div>
        <div class="mt-1 d-flex justify-content-end">
          <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button class="mt-1 me-1" @click="navegar('email', false)">
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <!-- <b-button variant="primary" class="mt-1" @click="navegar('contatos', true)">
            Próximo
          </b-button> -->
        </div>
      </div>
    </div>
    <div v-if="!tabela && !loading">
      <div class="row">
        <h6>
          Apenas contas bancárias de pessoa física são aceitas.
        </h6>
      </div>
      <div class="row">
        <p>
          Caso o seu Banco ou Agência não esteja disponível, entre em contato
          com a Unicampo para efetuar o cadastramento.
        </p>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Banco">
            <multiselect
              v-model="selectBanco"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_bco"
              :options="optionBanco"
              @input="carregarAgencias"
              :disabled="disabledCampo"
            />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Agência">
            <multiselect
              v-model="selectAgencia"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="nm_agencia"
              :options="optionAgencia"
              :loading="loadingAgencias"
              :disabled="disabledCampo"
            >
              <span slot="noResult">Selecione um Banco.</span>
              <span slot="noOptions">Selecione um Banco.</span>
            </multiselect>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group class="mb-3" label="N° da Conta">
            <b-form-input
              v-model="nrConta"
              trim
              v-mask="'##########'"
              autocomplete="off"
              maxlength="10"
              type="text"
              :disabled="disabledCampo"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2 d-flex">
          <b-form-group class="mb-3" label="DV">
            <b-form-input
              v-model="dvConta"
              trim
              autocomplete="off"
                :maxlength="dvMaxLength"
              min="0"
              type="text"
              @input="validateValue"
              @blur="$v.dvConta.$touch()"
              :class="{
                'is-invalid': $v.dvConta.$dirty && $v.dvConta.$invalid,
                'is-valid': $v.dvConta.$dirty && !$v.dvConta.$invalid,
              }"
            ></b-form-input>
            <b-form-invalid-feedback v-if="$v.dvConta.$dirty && $v.dvConta.$invalid">
              O campo DV é obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label="Tipo de Conta">
            <multiselect
              v-model="selectTipoConta"
              placeholder="Selecione"
              :show-labels="false"
              :allow-empty="false"
              label="label"
              :options="optionTipoConta"
              :disabled="disabledCampo"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-form-checkbox
              id="checkbox-1"
              v-model="stPrincipal"
              :unchecked-value="false"
              :value="true"
              :disabled="disabledPrincipal == true"
              plain
            >
              Conta Bancária Principal
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
              class="mt-1 me-1"
              @click="tabela = true"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            class="mt-1 me-1"
            variant="success"
            @click="salvar()"
            :disabled="disabledSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              variant="primary"
              small
              class="ms-2"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators"; // Importa o validador required

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      optionBanco: [],
      optionAgencia: [],
      optionTipoConta: [
        {
          tp_conta: "C",
          label: "Conta Corrente",
        }
      ],
      selectBanco: {},
      selectAgencia: {},
      nrConta: "",
      dvConta: "",
      selectTipoConta: {},
      stPrincipal: "",
      disabledPrincipal: "",
      camposInfoBancarias: [
        {
          key: "NMBCO",
          label: "Banco",
          formatter: (value, row, column) => {
            return column.CDBCO + " - " + capitalizeString(value);
          },
        },
        {
          key: "NMAGENCIA",
          label: "Agência",
          formatter: (value, row, column) => {
            return (
              column.NRAGENCIA +
              "-" +
              column.DVAGENCIA +
              " " +
              capitalizeString(value)
            );
          },
        },
        {
          key: "NRCTA",
          label: "Conta",
        },
        {
          key: "DVCTA",
          label: "DV",
        },
        {
          key: "CONTA",
          label: "Tipo de Conta",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
      ],
      dadosInfoBancarias: [],
      loading: true,
      tabela: true,
      avancar: null,
      loadingSalvar: false,
      disabledSalvar: false,
      loadingAgencias: false,
      disabledCampo: false,
    };
  },
    computed: {
      dvMaxLength() {
        if (!this.selectBanco || !this.selectBanco.nm_bco) return 1;
        const nomeBanco = this.selectBanco.nm_bco.toLowerCase();
        const bancosPermitidos = [
          "hsbc",
          "citibank",
          "agiplan",
          "agipag"
        ];
        return bancosPermitidos.some(banco => nomeBanco.includes(banco)) ? 2 : 1;
      }
    },

      watch: {
        selectBanco(newBanco) {
          if (!newBanco || !newBanco.nm_bco) {
            this.dvConta = "";
            return;
          }
          const nomeBanco = newBanco.nm_bco.toLowerCase();
          const bancosPermitidos = ["hsbc", "citibank", "agiplan", "agipag"];
          if (!bancosPermitidos.some(banco => nomeBanco.includes(banco))) {
            this.dvConta = "";
          }
        }
      },
  validations: {
    dvConta: {
      required,
    },
  },

  async created() {
    await this.buscarInfoBancarias();
  },

  methods: {
    async buscarInfoBancarias() {
      this.loading = true;
      this.dadosInfoBancarias = [];
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarInfoBancarias"),
        this.$http.get("api/cadastroCandidato/buscarLkpBancos"),
      ]).then(([responseInfoBancarias, responseLkpBanco]) => {
        this.dadosInfoBancarias = responseInfoBancarias.data;
        this.optionBanco = responseLkpBanco.data.map((item) => {
          return {
            ...item,
            nm_bco: item.cd_bco + " - " + capitalizeString(item.nm_bco),
          };
        });
        if (this.dadosInfoBancarias.length == 0) {
          this.stPrincipal = true;
          this.disabledPrincipal = true;
        } else {
          this.stPrincipal = false;
          this.disabledPrincipal = "";
        }
      });
      this.loading = false;
    },

    async carregarAgencias() {
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      this.selectAgencia = null;
      this.optionAgencia = [];
      this.loadingAgencias = true;
      try {
        const response = await this.$http.get(
          "api/cadastroCandidato/buscarLkpAgencia/" + this.selectBanco.cd_bco
        );
        this.optionAgencia = response.data.map((item) => {
          return {
            ...item,
            nm_agencia:
              item.nr_agencia +
              "-" +
              item.dv_agencia +
              " " +
              capitalizeString(item.nm_agencia),
          };
        });
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      } finally {
        this.loadingAgencias = false;
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },

    async salvar() {
      this.$v.$touch(); // Marca todos os campos como tocados para validação
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      if (
        !this.selectBanco ||
        !this.selectAgencia ||
        !this.nrConta ||
        this.nrConta == null ||
        this.nrConta <= 0 ||
        !this.dvConta ||
        !this.selectTipoConta
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        return;
      }

      const item = {
        cdBanco: this.selectBanco.cd_bco,
        nrAgencia: this.selectAgencia.nr_agencia,
        nrConta: this.nrConta,
        dvConta: this.dvConta,
        tpConta: this.selectTipoConta.tp_conta,
        stPrincipal: this.stPrincipal ? "S" : "N",
      };

      try {
        await this.$http.post(
          "api/cadastroCandidato/incluirInformacoesBancarias",
          item
        );

        this.tabela = !this.tabela;
        this.buscarInfoBancarias();
        this.$emit("carregarNivelPerfil");
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      } finally {
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    incluir() {
      this.disabledCampo = false;
      (this.selectBanco = ""),
        (this.selectAgencia = ""),
        (this.nrConta = ""),
        (this.dvConta = ""),
        (this.selectTipoConta = ""),
        (this.optionAgencia = []),
        (this.tabela = false);
      if (this.dadosInfoBancarias.length == 0) {
        this.stPrincipal = true;
        this.disabledPrincipal = true;
      } else {
        this.stPrincipal = false;
        this.disabledPrincipal = "";
      }
    },

    async editarInfoBancarias(data) {
      this.disabledCampo = true;
      this.selectBanco = this.optionBanco.find((el) => el.cd_bco == data.CDBCO);
      this.nrConta = data.NRCTA;
      this.dvConta = data.DVCTA;
      this.selectTipoConta = this.optionTipoConta.find(
        (el) => el.tp_conta == data.TPCONTA
      );
      this.stPrincipal = data.STPRINCIPAL == "S" ? true : false;
      this.disabledPrincipal = data.STPRINCIPAL == "S" ? true : false;
      this.carregarAgencias().then(() => {
        this.preencherAgencia(data.NRAGENCIA);
      });

      this.tabela = false;
    },

    preencherAgencia(nrAgencia) {
      this.selectAgencia = this.optionAgencia.find(
        (el) => el.nr_agencia == nrAgencia
      );
    },

    async excluirInfoBancarias(data) {
      var item = {};
      item.cdBanco = data.CDBCO;
      item.nrAgencia = data.NRAGENCIA;
      item.nrConta = data.NRCTA;

      if (data.STPRINCIPAL === "S") {
        this.$tools.alerta(
          "Não é possível excluir uma informação bancária principal",
          "error"
        );
      } else {
        try {
          await this.$http.post(
            "api/cadastroCandidato/excluirInformacoesBancarias",
            item
          );
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        } finally {
          this.buscarInfoBancarias();
        }
      }
    },

    validateValue() {
      if (this.dvConta < 0) {
        this.dvConta = 0;
      }
    },
  },
};
</script>